import { createMockListPage } from "./listingMocks";
import { matchesAcademyIds, matchesOptionalNumber } from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID } from "./mockFilterHelpers";
import { demoApi } from "./demoLocale";

export const mockAcademyBranches = [
  {
    AcademyId: DEMO_ACADEMY_ID,
    Name: "Klub piłkarski",
    IsMainBranch: true,
    Type: 0,
    Visibility: 0,
    AccessStatus: 0,
    Address: { City: "Kraków", Street: "ul. Sportowa 12" },
  },
  {
    AcademyId: "00000000-0000-0000-0000-000000000011",
    Name: "Oddział Akademii",
    IsMainBranch: false,
    Type: 0,
    Visibility: 1,
    AccessStatus: 2,
    Address: { City: "Warszawa", Street: "ul. Piłkarska 5" },
  },
  {
    AcademyId: "00000000-0000-0000-0000-000000000012",
    Name: "Oddział Akademii - Zachodni",
    IsMainBranch: false,
    Type: 2,
    Visibility: 0,
    AccessStatus: 1,
    Address: { City: "Katowice", Street: "ul. Młodzieżowa 8" },
  },
  {
    AcademyId: "00000000-0000-0000-0000-000000000013",
    Name: "Sekcja kobieca",
    IsMainBranch: false,
    Type: 2,
    Visibility: 1,
    AccessStatus: 1,
    Address: { City: "Płock", Street: "ul. Jasna 18" },
  },
];

const academyFilters = [
  (branch: typeof mockAcademyBranches[number], pageInfo: any) =>
    matchesOptionalNumber(branch.Type, pageInfo.Type),
  (branch: typeof mockAcademyBranches[number], pageInfo: any) =>
    matchesOptionalNumber(branch.Visibility, pageInfo.Visibility),
  (branch: typeof mockAcademyBranches[number], pageInfo: any) =>
    matchesOptionalNumber(branch.AccessStatus, pageInfo.ActivityLevel),
];

export const getMockAcademyBranchesPage = demoApi((pageInfo: any) =>
  createMockListPage(mockAcademyBranches, pageInfo, {
    search: (branch, search) =>
      branch.Name.toLowerCase().includes(search) ||
      branch.Address.City.toLowerCase().includes(search),
    filters: academyFilters,
  }));
